/* Physical bundle demand is supplied by Liquid item_components, whose quantities already include parent quantity. */
((root) => {
  'use strict';
  const num = value => Number.isSafeInteger(value) && value >= 0;
  const id = value => String(value);
  const fingerprint = cart => JSON.stringify([cart?.currency,cart?.total_price ?? cart?.total,(cart?.items || []).map(item => [item.key || id(item.id), item.quantity]).sort((a,b) => a[0].localeCompare(b[0]))]);
  function demand(snapshot) {
    const used = new Map();
    const nestedKeys = new Set(snapshot.items.flatMap(item => (item.components || []).map(part => part.key)));
    for (const item of snapshot.items) {
      if (!num(item.quantity) || !item.id || !Array.isArray(item.components)) return null;
      if (item.set && !item.components.length) return null;
      if (!item.components.length && nestedKeys.has(item.key)) continue;
      const physical = item.components.length ? item.components : [item];
      for (const part of physical) {
        if (!part.id || !num(part.quantity) || !part.key) return null;
        used.set(id(part.id), (used.get(id(part.id)) || 0) + part.quantity);
      }
    }
    return used;
  }
  const remaining = (variant, used) => variant && variant.available === true && variant.tracked === true && variant.policy === 'deny' && num(variant.quantity) ? variant.quantity - (used.get(id(variant.id)) || 0) : null;
  function offers(snapshot, policy, now = Date.now()) {
    if (!snapshot || snapshot.version !== 1 || !Array.isArray(snapshot.items) || snapshot.currency !== 'GBP' || snapshot.country !== 'GB' || !Number.isFinite(Number(snapshot.at)) || Math.abs(now - Number(snapshot.at) * 1000) > 30000) return [];
    const used = demand(snapshot);
    if (!used) return [];
    const sets = snapshot.items.filter(item => item.set && item.price === 3995 && item.quantity > 0);
    if (!sets.length) return [];
    const componentKeys = new Set(snapshot.items.flatMap(item => item.components.map(part => part.key)));
    const extras = snapshot.items.filter(item => item.spare && !item.components.length && !componentKeys.has(item.key)).reduce((sum, item) => sum + item.quantity, 0);
    const reserve = num(policy.reserve) ? policy.reserve : 2;
    const floor = num(policy.floor) ? policy.floor : 2;
    const spareCandidates = [];
    if (snapshot.sparePromotionAllowed === true && extras < 2 && now < Date.parse(policy.ends)) {
      for (const [setIndex, set] of sets.entries()) {
        if (set.components.length !== 2) continue;
        for (const part of set.components) {
          const product = part.product, opposite = set.components.find(other => other !== part)?.product;
          if (!product?.spare || !opposite?.spare) continue;
          const selected = product.variants.find(variant => id(variant.id) === id(part.id));
          if (!selected) continue;
          const variants = [];
          for (const variant of product.variants) {
            // Compare corresponding sizes while respecting the independently selected sizes in cart demand.
            const other = opposite.variants.find(candidate => candidate.options?.[0] === variant.options?.[0]);
            const left = remaining(variant, used), otherLeft = remaining(other, used);
            if (left === null || otherLeft === null || variant.price !== 1995 || left - 1 < reserve) continue;
            const surplus = left > otherLeft;
            if (!surplus && otherLeft < floor) continue;
            variants.push({ ...variant, left, surplus });
          }
          const matching = variants.find(variant => id(variant.id) === id(selected.id));
          // Never recommend another size merely because the corresponding size is scarce.
          if (matching) spareCandidates.push({ type: 'spare', product, variants, selected: id(matching.id), price: 995, remaining: 2-extras, surplus: matching.surplus, gap: matching.left - (remaining(opposite.variants.find(v => v.options?.[0] === matching.options?.[0]), used) || 0), setIndex });
        }
      }
    }
    spareCandidates.sort((a,b) => a.setIndex-b.setIndex || Number(b.surplus)-Number(a.surplus) || b.gap-a.gap || a.product.handle.localeCompare(b.product.handle));
    if (spareCandidates.length) return spareCandidates;
    if (snapshot.items.some(item => item.hoodie)) return [];
    return (snapshot.hoodies || []).map(product => ({ type:'hoodie', product, selected:'', price:2995, variants:product.variants.filter(variant => variant.price === 2995 && remaining(variant,used) >= 1) })).filter(offer => offer.variants.length);
  }
  const api = { demand, remaining, offers, fingerprint };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.PaxStockRules = api;
})(typeof window !== 'undefined' ? window : globalThis);
